import React, { useRef } from "react"
import { useEffect, useState } from "react"
import { useFormik } from "formik"
import * as Yup from "yup"
import { TextField, Button, Autocomplete, Box, Checkbox, Typography } from "@mui/material"
import { useLocation, useNavigate, useParams } from "react-router-dom"
import {
  ApiAddAreaManager,
  ApiGetAreaManager,
  ApiGetClientDbName,
  ApiGetClientEntityByClientGroupId,
  ApiGetClientEntityListById,
  ApiGetClients,
  ApiGetVenueList,
  ApiUpdateAreaManager,
} from "../../../apiService/Core/Apicall.tsx"
import { toast } from "react-toastify"
import { useSelector } from "react-redux"
import { RootState } from "../../../global/config/store.ts"
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";

const roleOptions = [
  { label: "Area Manager", value: "areaManager" },
  { label: "Director", value: "director" },
  { label: "PA", value: "pa" }
];

interface AreaFormProps {
  initialValues?: {
    firstName: string
    lastName: string
    areaName: string
    userName: string
    password: string
    venueList: string[]
    regionList: string[]
    email: string
    createPassword: string
    confirmPassword: string
    role: string,
  }
  onSubmit: (values: any) => void
  mode: "add" | "update"
}
const AddOrUpdateAreaManager: React.FC<AreaFormProps> = ({
  initialValues = {
    areaName: "",
    userName: "",
    password: "",
    venueList: [],
    regionList: [],
    email: "",
    firstName: "",
    lastName: "",
    createPassword: "",
    confirmPassword: "",
    role: "",
  },
  onSubmit,
}) => {
  const location = useLocation()
  // const areaManager = location?.state?.areaManager
  const [areaManager, setAreaManager] = useState<any>([])
  const [venues, setVenues] = useState<any[]>([])
  const [error, setError] = useState<string | null>(null)
  const [loading, setLoading] = useState<boolean>(false)
  const navigate = useNavigate()
  const { mode, id } = useParams<{ mode: "add" | "update"; id?: string }>()
  const [clientGroupOptions, setClientGroupOptions] = useState([])
  const [clientOptions, setClientOptions] = useState<any[]>([])
  const [selectedClientGroup, setSelectedClientGroup] = useState()
  const [clientEntities, setClientEntities] = useState([])
  const [clientId, setClientId] = useState<string | null>(null)
  const [clientEntityId, setClientEntityId] = useState<string | null>(null)
  const Clientlist = useSelector((state: RootState) => state.client.clientList)
  const [selectedClient, setSelectedClient] = useState<any>(null)
  const [regions, setRegions] = useState<any[]>([])
  const [selectedRegion, setSelectedRegion] = useState<any>(null)

  const initialDataLoaded = useRef(false)
  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const checkedIcon = <CheckBoxIcon fontSize="small" />;


 const fetchAreaManagers = async () => {
    try {
      let data = `?areaId=${id}`
      const response = await ApiGetAreaManager(data)
      setAreaManager(response?.data[0])
    } catch (error) {
      console.error('Error fetching area managers:', error)
    }
  }

  useEffect(() => {
   id && fetchAreaManagers()
  }, [id])

  // console.log(areaManager)
  useEffect(() => {
    if (mode === "update" && id) {
      // console.log(`Fetching data for area with ID: ${id}`)
      // Here you would fetch the area manager data for editing
      // Example: fetchAreaManagerById(id);
    }
  }, [mode, id])

  useEffect(() => {
    if (mode === "update" && id) {
      // console.log(`Fetching data for client with ID: ${id}`)
    }
  }, [mode, id])

  useEffect(() => {
    if (selectedClient) {

      // fetchClientsByGroup(selectedClient?.clientGroupName);
      fetchBusinessesByClient(selectedClient.clientGroupName);
    }
  }, [selectedClient])

  useEffect(() => {
    if (areaManager?.areaId && mode === "update" && Clientlist.length > 0 && !initialDataLoaded.current) {
      initialDataLoaded.current = true;
      // Set form values
      formik.setValues({
        firstName: areaManager.firstName || "",
        lastName: areaManager.lastName || "",
        areaName: areaManager.areaName || "",
        userName: areaManager.userName || "",
        createPassword: "",
        confirmPassword: "",
        password: "", // Usually don't pre-fill password fields for security
        email: areaManager.emailId || "",
        venueList: areaManager.venueIds ? areaManager.venueIds.split(",").map((id: any) => id.trim()) : [],
        regionList: areaManager.regionIds ? areaManager.regionIds.split(",").map((id: any) => id.trim()) : [],
        role: areaManager.role || "",
      })

      // Find and set client group
      if (areaManager.clientGroupName) {
        const clientGroup = Clientlist.find((group: any) => group.clientGroupName === areaManager.clientGroupName)
        if (clientGroup) {
          setSelectedClient(clientGroup)
          // fetchClientsByGroup(clientGroup.clientGroupName)
          fetchBusinessesByClient(clientGroup.clientGroupName)
        }
      }

      // Set client ID
      // if (areaManager.ClientID) {
      //   setClientId(areaManager.ClientID)
      //   fetchBusinessesByClient(areaManager.ClientID)
      // }

      // Set client entity ID
      if (areaManager.clientEntityId) {
        setClientEntityId(areaManager.clientEntityId)
      }
    }
  }, [areaManager, mode, Clientlist.length])

  useEffect(() => {
    if (areaManager && mode === "update" && clientEntities.length > 0 && clientEntityId && initialDataLoaded.current) {
      const business: any = clientEntities.find((b: any) => b.clientEntityId === clientEntityId)

      if (business) {
        if (areaManager.clientGroupName === "ALDI" && business.regions) {
          const regionOptions = business.regions.map((region: any) => ({
            label: region.regionName,
            value: region.regionId
          }));
          setRegions(regionOptions);

          if (areaManager.regionIds) {
            const savedRegionIds = areaManager.regionIds.split(",").map((id: any) => id.trim());
            formik.setFieldValue("regionList", savedRegionIds);
            fetchVenues(clientEntityId, savedRegionIds);
          } else {
            // ALDI but no regionIds - fetch all venues
            fetchVenues(clientEntityId);
          }
        } else {
          // Non-ALDI client - fetch all venues without region filter
          fetchVenues(clientEntityId);
        }
      }
    }
  }, [clientEntities.length, clientEntityId, mode])
  const formik = useFormik({
    enableReinitialize: true,
    initialValues,
    validationSchema: Yup.object({
      firstName: Yup.string().required("First Name is required"),
      lastName: Yup.string().required("Last Name is required"),
      areaName: Yup.string().required("Area Name is required"),
      role: Yup.string().required("Role is required"),
      // userName: Yup.string().required("User Name is required"),
      email: Yup.string().email("Invalid email format").required("Email is required"),
      venueList: Yup.array().min(1, "At least one venue must be selected"),
      ...(mode === "add"
        ? {
          createPassword: Yup.string()
            .min(6, "Password must be at least 6 characters")
            .required("Create Password is required"),
          confirmPassword: Yup.string()
            .oneOf([Yup.ref("createPassword")], "Passwords must match")
            .required("Confirm Password is required"),
        }
        : {
          createPassword: Yup.string()
            .min(6, "Password must be at least 6 characters")
            .test('password-match', 'Passwords must match', function (value) {
              const { confirmPassword } = this.parent;
              if (!value && !confirmPassword) return true;
              if (value && confirmPassword) return value === confirmPassword;
              return false;
            }),
          confirmPassword: Yup.string()
            .test('password-match', 'Passwords must match', function (value) {
              const { createPassword } = this.parent;
              if (!value && !createPassword) return true;
              if (value && createPassword) return value === createPassword;
              return false;
            }),
        }),

    }),
    onSubmit: async (values) => {
      const formData = {
        areaName: values.areaName,
        clientEntityId: clientEntityId,
        // userName: values.userName,
        // clientId: clientId,
        emailId: values.email,
        venueIds: values.venueList.join(","),
        regionIds: values.regionList.join(","),
        firstName: values.firstName,
        lastName: values.lastName,
        password: values.createPassword,
        role: values.role,
        createdBy: Number(localStorage.getItem('createdBy')),
      }

      setLoading(true)
      setError(null)

      try {
        if (mode === "add") {
          // console.log(formData)
          // Call API to add a new area manager
          const response = await ApiAddAreaManager(formData)
          toast.success("Area Manager added successfully!")
          navigate(-1) // Redirect to the area managers list page
        } else if (mode === "update" && id) {
          const data: any = {
            areaId: areaManager.areaId,
            areaName: values.areaName,
            clientEntityId: clientEntityId,
            userName: values.userName,
            emailId: values.email,
            venueIds: values.venueList.join(","),
            regionIds: values.regionList.join(","),
            modifiedBy: Number(localStorage.getItem('createdBy')),
            firstName: values.firstName,
            lastName: values.lastName,
            role: values.role,
          }
          if (values.createPassword && values.createPassword.trim() !== "") {
            data.password = values.createPassword;
          }
          // Call API to update an existing area manager
          await ApiUpdateAreaManager(data);
          toast.success("Area Manager updated successfully!")
          navigate(-1) // Redirect to the area managers list page
        }
      } catch (error: any) {
        console.error("Error during API call:", error)
        setError(error?.response?.data.message || "An error occurred")
        toast.error(error?.response?.data.message || "Failed to save Area Manager")
      } finally {
        setLoading(false)
      }
    },
  })

  const fetchBusinessesByClient = async (clientGroup: any) => {
    const data = `?ClientGroupName=${clientGroup}&clientEntityStatus=active`
    try {
      const response: any = await ApiGetClientEntityByClientGroupId(data)
      const fullBusinessData = response.data || []
      setClientEntities(response.data)
      // console.log("Business response:", response.data)
    } catch (error) {
      console.error("Failed to fetch businesses:", error)
      toast.error("Failed to fetch businesses")
    }
  }


  // const fetchClientsByGroup = async (clientGroup: string) => {
  //   const data = `?status=active&clientGroup=${clientGroup}`
  //   try {
  //     const response = await ApiGetClients(data)

  //     setClientOptions(response.data)
  //   } catch (error) {
  //     console.error("Failed to fetch clients:", error)
  //     toast.error("Failed to fetch clients")
  //   }
  // }

  const fetchVenues = async (clientEntityId: any, regionIds?: any) => {
    try {
      let data = `?clientEntityId=${clientEntityId}&offset=0&limit=1000&venueStatus=active`;

      // Only add regionIds if they exist and have values
      if (regionIds && Array.isArray(regionIds) && regionIds.length > 0) {
        data += `&regionIds=${regionIds.join(",")}`;
      }

      const res = await ApiGetVenueList(data)
      setVenues(res.data)

      if (mode === "update" && areaManager?.venueIds && !formik.values.venueList.length) {
        const savedVenueIds = areaManager.venueIds.split(",").map((v: any) => v.trim());
        formik.setFieldValue("venueList", savedVenueIds);
      }
    } catch (error) {
      console.error("Error fetching venues:", error)
    }
  }

  const isSpecialClient = selectedClient?.clientGroupName === "ALDI";

  useEffect(() => {
    if (!clientEntityId) return;

    if (isSpecialClient) {
      // For ALDI, fetch venues with selected regions (or without if no regions selected)
      if (formik.values.regionList.length > 0) {
        fetchVenues(clientEntityId, formik.values.regionList);
      } else {
        fetchVenues(clientEntityId); // Fetch all venues without region filter
      }
    } else {
      // For non-special clients, always fetch all venues without region filter
      fetchVenues(clientEntityId);
    }
  }, [clientEntityId, formik.values.regionList, isSpecialClient]);

  // useEffect(() => {
  //   if (
  //     mode === "update" &&
  //     areaManager &&
  //     selectedClient &&
  //     clientEntityId &&
  //     (!isSpecialClient || (isSpecialClient && selectedRegion))
  //   ) {
  //     console.log("Auto fetching venues for update:", {
  //       clientEntityId,
  //       regionId: areaManager.regionId || selectedRegion?.value,
  //     });
  //     fetchVenues(clientEntityId, areaManager.regionId || selectedRegion?.value);
  //   }
  // }, [mode, areaManager, selectedClient, clientEntityId, selectedRegion]);

  return (
    <Box className='w-100 p-2'>
    <Box
      component="form"
      onSubmit={formik.handleSubmit}
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 2,
        maxWidth: 800,
        margin: "auto",
        padding:{xs:2,md:3},
        backgroundColor: "#f9f9f9",
        borderRadius: 2,
        boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
      }}
    >
      <Typography className="fs-42 text-center">{mode === "add" ? "Add New Area Manager" : "Update Area Manager"}</Typography>

      <div>
        <Autocomplete
          options={Clientlist}
          value={selectedClient}
          getOptionLabel={(option: any) => option?.clientGroupName || ""}
          isOptionEqualToValue={(option, value) => option.clientGroupDBName === value.clientGroupDBName}
          onChange={(event, newValue: any) => {
            setSelectedClient(newValue)
            setClientId(newValue?.clientGroupName || null)
            if (
              !newValue ||
              (selectedClient && newValue.clientGroupName !== selectedClient.clientGroupName)
            ) {
              setClientEntityId(null)
              formik.setFieldValue("regionList", [])
              formik.setFieldValue("venueList", [])
            }
          }}
          renderInput={(params) => <TextField {...params} label="Select Client Group" />}
          fullWidth
        />
      </div>
      {/* <div>
        <Autocomplete
          options={clientOptions}
          value={clientId ? clientOptions.find((option) => option.ClientID === clientId) : null}
          getOptionLabel={(option) => option?.ClientName || ""}
          onChange={(event, newValue) => {
            if (newValue) {
              setClientId(newValue.ClientID)
              fetchBusinessesByClient(newValue.ClientID)
            } else {
              setClientId(null)
            }
          }}
          renderInput={(params) => <TextField {...params} label="Select Client" />}
          fullWidth
        />
      </div> */}
      <div>
        <Autocomplete
          options={clientEntities}
          value={clientEntityId ? clientEntities.find((option: any) => option.clientEntityId === clientEntityId) : null}
          getOptionLabel={(option: any) => option?.entityName || ""}
          onChange={(event, newValue) => {
            if (newValue) {
              setClientEntityId(newValue.clientEntityId)

              if (isSpecialClient && newValue.regions && newValue.regions.length > 0) {
                const regionOptions = newValue.regions.map((region: any) => ({
                  label: region.regionName,
                  value: region.regionId
                }))
                setRegions(regionOptions)
                formik.setFieldValue("regionList", [])
              } else {
                setRegions([])
                formik.setFieldValue("regionList", [])
                fetchVenues(newValue.clientEntityId)
              }
              formik.setFieldValue("venueList", [])
            } else {
              setClientEntityId(null)
              setRegions([])
              formik.setFieldValue("regionList", [])
              setVenues([])
              formik.setFieldValue("venueList", [])
            }
          }}
          renderInput={(params) => <TextField {...params} label="Select Business" />}
          fullWidth
        />
      </div>
      <div>
        {isSpecialClient && regions.length > 0 && (
          <div>
            <Autocomplete
              multiple
              disableCloseOnSelect
              options={
                regions.length > 0
                  ? [{ label: "Select All Regions", value: "ALL" }, ...regions]
                  : []
              }
              getOptionLabel={(option) => option?.label || ""}
              value={
                formik.values.regionList && regions.length > 0
                  ? regions.filter(
                    (region) =>
                      formik.values.regionList.includes(region.value) ||
                      formik.values.regionList.includes(String(region.value))
                  )
                  : []
              }
              onChange={(event, value, reason, details) => {
                if (!value) return;

                const isSelectAllClicked = value.some((v) => v.value === "ALL");

                if (isSelectAllClicked) {
                  const allSelected = formik.values.regionList.length === regions.length;

                  if (allSelected) {
                    formik.setFieldValue("regionList", []);
                    formik.setFieldValue("venueList", []);
                    setVenues([]);
                  } else {
                    const allRegionIds = regions.map((r) => r.value);
                    formik.setFieldValue("regionList", allRegionIds);
                  }
                } else {
                  const filtered = value.filter((v) => v.value !== "ALL");
                  const selectedValues = filtered.map((item) => item.value);
                  formik.setFieldValue("regionList", selectedValues);

                  if (selectedValues.length === 0) {
                    formik.setFieldValue("venueList", []);
                    setVenues([]);
                  }
                }
              }}
              renderOption={(props, option, { selected }) => {
                const isAll = option.value === "ALL";
                const allSelected = formik.values.regionList.length === regions.length;

                return (
                  <li {...props}>
                    <Checkbox
                      icon={icon}
                      checkedIcon={checkedIcon}
                      checked={isAll ? allSelected : selected}
                      style={{ marginRight: 8 }}
                    />
                    {option.label}
                  </li>
                );
              }}
              noOptionsText="No regions available"
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Select Region(s)"
                  error={formik.touched.regionList && Boolean(formik.errors.regionList)}
                  helperText={formik.touched.regionList && formik.errors.regionList}
                />
              )}
              fullWidth
            />
          </div>
        )}
      </div>
      <TextField
        label="First Name"
        name="firstName"
        value={formik.values.firstName}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={formik.touched.firstName && Boolean(formik.errors.firstName)}
        helperText={formik.touched.firstName && formik.errors.firstName}
        fullWidth
      />
      <TextField
        label="Last Name"
        name="lastName"
        value={formik.values.lastName}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={formik.touched.lastName && Boolean(formik.errors.lastName)}
        helperText={formik.touched.lastName && formik.errors.lastName}
        fullWidth
      />
      <TextField
        label="Area Name"
        name="areaName"
        value={formik.values.areaName}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={formik.touched.areaName && Boolean(formik.errors.areaName)}
        helperText={formik.touched.areaName && formik.errors.areaName}
        fullWidth
      />
      {/* <TextField
        label="User Name"
        name="userName"
        value={formik.values.userName}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={formik.touched.userName && Boolean(formik.errors.userName)}
        helperText={formik.touched.userName && formik.errors.userName}
        fullWidth
      /> */}
      <TextField
        label="Email ID"
        name="email"
        value={formik.values.email}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={formik.touched.email && Boolean(formik.errors.email)}
        helperText={formik.touched.email && formik.errors.email}
        fullWidth
      />
      {/* <Autocomplete
        multiple
        options={venues || []}
        getOptionLabel={(option) => option?.venueName || ""}
        value={
          formik.values.venueList && venues.length > 0
            ? venues.filter(
              (venue) =>
                formik.values.venueList.includes(venue.venueId) ||
                formik.values.venueList.includes(String(venue.venueId)),
            )
            : []
        }
        onChange={(event, value) => {
          const selectedValues = value.map((item) => item.venueId)
          formik.setFieldValue("venueList", selectedValues)
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Venue List"
            error={formik.touched.venueList && Boolean(formik.errors.venueList)}
            helperText={formik.touched.venueList && formik.errors.venueList}
          />
        )}
        fullWidth
      /> */}

      <Autocomplete
        multiple
        disableCloseOnSelect
        options={
          venues.length > 0
            ? [{ venueId: "ALL", venueName: "Select All Venues" }, ...venues]
            : []
        }
        getOptionLabel={(option) => option?.venueName || ""}
        value={
          formik.values.venueList && venues.length > 0
            ? venues.filter(
              (venue) =>
                formik.values.venueList.includes(venue.venueId) ||
                formik.values.venueList.includes(String(venue.venueId))
            )
            : []
        }
        onChange={(event, value, reason, details) => {
          if (!value) return;

          const isSelectAllClicked = value.some((v) => v.venueId === "ALL");

          if (isSelectAllClicked) {
            const allSelected = formik.values.venueList.length === venues.length;

            if (allSelected) {
              formik.setFieldValue("venueList", []);
            } else {
              formik.setFieldValue(
                "venueList",
                venues.map((v) => v.venueId)
              );
            }
          } else {
            const filtered = value.filter((v) => v.venueId !== "ALL");
            const selectedValues = filtered.map((item) => item.venueId);
            formik.setFieldValue("venueList", selectedValues);
          }
        }}
        renderOption={(props, option, { selected }) => {
          const isAll = option.venueId === "ALL";
          const allSelected = formik.values.venueList.length === venues.length;

          return (
            <li {...props}>
              <Checkbox
                icon={icon}
                checkedIcon={checkedIcon}
                checked={isAll ? allSelected : selected}
                style={{ marginRight: 8 }}
              />
              {option.venueName}
            </li>
          );
        }}
        noOptionsText="No venues available"
        renderInput={(params) => (
          <TextField
            {...params}
            label="Venue List"
            error={formik.touched.venueList && Boolean(formik.errors.venueList)}
            helperText={formik.touched.venueList && formik.errors.venueList}
          />
        )}
        fullWidth
      />
      <Autocomplete
        options={roleOptions}
        getOptionLabel={(option) => option?.label || ""}
        value={roleOptions.find((option) => option.value === formik.values.role) || null}
        onChange={(event, newValue) => {
          formik.setFieldValue("role", newValue ? newValue.value : "")
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Select Role"
            error={formik.touched.role && Boolean(formik.errors.role)}
            helperText={formik.touched.role && formik.errors.role}
          />
        )}
        fullWidth
      />
      <Box display="flex" flexWrap={'wrap'} gap={2}>
        <TextField
          label={mode === "add" ? "Create Password" : "New Password (Optional)"}
          name="createPassword"
          type="password"
          value={formik.values.createPassword}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.touched.createPassword && Boolean(formik.errors.createPassword)}
          helperText={formik.touched.createPassword && formik.errors.createPassword}
          // fullWidth
          className="col-12 col-md-grow"
        />
        <TextField
          label={mode === "add" ? "Confirm Password" : "Confirm New Password"}
          name="confirmPassword"
          type="password"
          value={formik.values.confirmPassword}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.touched.confirmPassword && Boolean(formik.errors.confirmPassword)}
          helperText={formik.touched.confirmPassword && formik.errors.confirmPassword}
          // fullWidth
          className="col-12 col-md-grow"
        />
      </Box>

      <div style={{ color: "red" }}>{error}</div>
      <Button type="submit" variant="contained" color="primary" className="table-row-background" disabled={loading}>
        {loading ? "Saving..." : mode === "add" ? "Add Area" : "Update Area"}
      </Button>
    </Box>
    </Box>
  )
}

export default AddOrUpdateAreaManager
